const VERSIONED_UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export const SHARED_POST_QUERY_PARAM = 'shared_post_id'

export function getSharedPostIDFromLocation(): string | null {
  if (typeof window === 'undefined') return null
  const value = new URLSearchParams(window.location.search).get(SHARED_POST_QUERY_PARAM)?.trim() || ''
  return VERSIONED_UUID_PATTERN.test(value)
    ? value
    : null
}
